
import { colors, fonts } from '../../shared/styles';
import { assign } from 'lodash';

const largeButtonBase = (isRegister) => ({
  height: '40px',
  lineHeight: '14px',
  boxSizing: 'border-box',
  display: 'inline-block',
  width: '100%',
  padding: '15px 20px',
  backgroundColor: isRegister ? colors.blue : colors.white,
  color: isRegister ? colors.white : colors.grey,
  fontFamily: fonts.heavy.fontFamily,
  fontSize: 14,
  fontWeight: 'bold',
  borderRadius: 3,
  cursor: 'pointer',
  textAlign: 'center',
  border: `1px solid ${isRegister ? colors.blue : colors.greyLine}`,
  maxWidth: '100%',
  marginBottom: 10
});

export const styles = {
  page: {
    backgroundColor: colors.lightGrey,
    WebkitTouchCallout:'none',
  },
  addRaceButtonContainer: {
    borderTop: `1px solid ${colors.lightGrey}`,
    paddingTop: '10px',
    margin: '10px 0px',
    marginTop: 0,
    width: '100%',
    display: 'inline-block',
    marginRight: 10
  },
  contentCard: (isMobile) => ({
    padding: isMobile ? '15px' : '12px',
    backgroundColor: colors.white,
    boxShadow: isMobile ? colors.cardShadow : '',
    fontSize: 14,
    marginBottom: isMobile ? 15 : 0,
  }),
  rightCol: (showingLeftCol) => ({
    paddingLeft: (showingLeftCol) ? 45 : 15,
  }),
  largeButton: (isRegister, isMobile) => (
    assign(
      largeButtonBase(isRegister),
      isMobile ?
        {
          margin: '10px 10px 5px 5px',
          padding: '10px',
          width: '95%',
          lineHeight: '18px',
        } :  {}
    )
  ),
  hoverRegisterOrLearn: (isRegister) => `
    .register-or-learn:hover {
      background-color: ${isRegister ? '#0092C9' : colors.snow} !important;
      color: ${isRegister ? colors.white : colors.black} !important;
    }
  `,
  learnMoreOrRegisterContainer: (isMobile) =>
    isMobile ?
      ({
        width: '100%'
      }) :
      ({
        display: 'flex',
        paddingBottom: '10px',
        justifyContent: 'center'
      }),
  buttonContainer: (showBorderTop = true) => ({
    borderTop: showBorderTop ? `1px solid ${colors.lightGrey}` : 'none',
    paddingTop: '10px',
    margin: '10px 0px'
  }),
  leftContainer: {
    padding: '20px',
    backgroundColor: colors.white,
    marginBottom: 15,
    boxShadow: colors.cardShadow
  },
  commitmentMessage: {
    fontSize: '12px',
    lineHeight: '15px',
    align: 'left',
    ...fonts.default,
    color: colors.darkType,
    paddingTop: '10px',
    paddingBottom: '15px'
  },
  stickyFooter: {
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'row',
    position: 'fixed',
    bottom: '0px',
    cursor: 'pointer',
    width: '100%',
    height: '60px',
    zIndex: 99,
    backgroundColor: 'white',
    borderTop: `1px solid ${colors.greyLine}`,
    paddingLeft: '5px',
    paddingRight: '5px'
  }
};
